/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidacyProfileEntryStore } from '../../axios/candidacyProfileEntryStore'
import type {
	CandidacyProfileEntryStoreError,
	CandidacyProfileEntryStorePathParams,
	CandidacyProfileEntryStoreRequest,
	CandidacyProfileEntryStoreResponse,
} from '../../types/CandidacyProfileEntryStore'

export const candidacyProfileEntryStoreMutationKey = () =>
	[{ url: '/candidate-center/organisations/:organisation/candidacies/:candidacy/profile/:section' }] as const

export type CandidacyProfileEntryStoreMutationKey = ReturnType<typeof candidacyProfileEntryStoreMutationKey>

export type CandidacyProfileEntryStoreVariables = {
	organisation: CandidacyProfileEntryStorePathParams['organisation']
	candidacy: CandidacyProfileEntryStorePathParams['candidacy']
	section: CandidacyProfileEntryStorePathParams['section']
	data: CandidacyProfileEntryStoreRequest
}

/** @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidacyProfileEntryController.php CandidacyProfileEntryController::store */
export function useCandidacyProfileEntryStore<TContext = unknown>(
	options?: UseMutationOptions<
		CandidacyProfileEntryStoreResponse,
		AxiosError<CandidacyProfileEntryStoreError>,
		CandidacyProfileEntryStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidacyProfileEntryStoreMutationKey(),
		mutationFn: ({ organisation, candidacy, section, data }: CandidacyProfileEntryStoreVariables) =>
			candidacyProfileEntryStore(organisation, candidacy, section, data, config).then(res => res.data),
		...options,
	})
}
